import { i18nSuffix, translateFactory } from '../../../Assets/helpers/translation/index.js';
const keys = (await import(`../i18n${i18nSuffix()}.json`)).ProductCompareBanner;

export default translateFactory(keys);
